<template>
    <div class="discover">
      <div class="header">
        <div class="tabs">
          <span v-for="(tab, idx) in tabList" :key="tab.id" :class="['tabs-item', {'active': activeIdx === idx}]" @click="handleTabClick(idx)">{{ tab.title }}</span>
        </div>
        <div class="search" @click="$router.push('/novel/search')">
          Click To View Hot Search
          <img
            src="@/assets/images/icon/search.png"
            alt=""
          >
        </div>
      </div>
      <!-- banner -->
      <Banner :data="bannerList" v-if="bannerList.length" @goDetail="goDetail" />
      <!-- column -->
      <div class="column-box">
        <div class="column" v-for="item in columnList" :key="item.icon" @click="handleColumnClick(item.path)">
          <img :src="require(`@/assets/images/icon/${item.icon}.png`)" alt="" />
          <span>{{ item.name }}</span>
        </div>
      </div>
      <template v-for="data in pageData">
        <div class="content" :key="data.id" v-if="data.title !== 'banner'">
          <TitleBar :title="data.title" @goMore="goMore(data)"/>
          <List :data="data.items" :displayStyle="data.style" @goDetail="goDetail" />
        </div>
      </template>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import {
  getHomeChannel, getHomeChannelData, getNovelChapters,
} from '@/api';
import { getUrlParams, getItem, setItem } from '@/utils';
import TitleBar from '@/components/TitleBar';
import List from '@/components/List';
import Join from '@/components/Join';
import Rewards from '@/components/Rewards';
import Banner from './components/Banner';

const visittKey = 'ever_visit';

export default {
  name: 'Promt',
  components: {
    TitleBar, Banner, List, Join, Rewards,
  },
  data() {
    return {
      columnList: [
        { name: 'Rewards', icon: 'sign', path: 'rewards' },
        { name: 'Wallet', icon: 'wallet', path: '/topup' },
        { name: 'Premium', icon: 'member', path: '/premium' },
        { name: 'Mine', icon: 'history', path: '/mine' },
      ],
      activeIdx: 0,
      tabList: [],
      bannerList: [],
      pageData: [],
      showJoin: false,
      showRewards: false,
    };
  },
  computed: {
  },
  created() {
    this.init();
  },
  methods: {
    ...mapActions(['setMoreTitle']),
    async init() {
      const isVisited = getItem(visittKey);
      const { dl = '' } = getUrlParams();
      if (!dl || !dl.includes('_') || isVisited) {
        this.$promt();
      } else {
        const loading = this.$loading();
        // 漫画/章节/pm
        const [novelId, id, key] = dl.split('_');
        console.log(key);
        setItem(visittKey, true);
        if (!id) {
          this.goDetail(novelId);
        } else {
          this.$router.push(`/novel/${novelId}/chapter/${id}`);
        }
        loading.close();
      }
      await this.getChannel();
    },
    async getChannel() {
      const res = await getHomeChannel();
      if (res.code !== 0) return;
      this.tabList = res?.data || [];
      await this.getPageData();
    },
    async getPageData() {
      const id = this.tabList?.[this.activeIdx]?.id ?? '';
      const res = await getHomeChannelData(id);
      if (res.code !== 200) return;
      this.bannerList = res?.data?.web_banners?.items ?? [];
      this.pageData = res?.data || {};
    },
    async handleTabClick(idx) {
      this.activeIdx = idx;
      await this.getPageData();
    },
    handleColumnClick(path) {
      if (path === 'rewards') {
        this.$promt({ type: 'rewards' });
      } else {
        this.$router.push(path);
      }
    },
    async goDetail(novelId) {
      const res = await getNovelChapters(novelId);
      if (res.code !== 0) return;
      const { id = '' } = res.data[0];
      this.$router.push(`/novel/${novelId}/chapter/${id}`);
    },
    goMore(item) {
      const { id, title } = item;
      this.setMoreTitle(title);
      this.$router.push(`/channel/${id}`);
    },
    handleCloseJoin() {
      this.showJoin = false;
      this.showRewards = true;
    },
  },
};
</script>

<style lang="less" scoped>
.discover {
  background-image: linear-gradient(#adf4cc 0%, #e4fce5 90px, #fff 200px);
  height: 100%;
  font-size: 16px;
  .tabs {
    padding: 10px 16px;
    overflow-y: auto;
    .tabs-item {
      color: @gray;
      font-size: @fontLarge;
      font-weight: 700;
      margin-right: 8px;
      white-space: nowrap;
      &.active {
        color: @black;
      }
    }
  }
  .search {
    margin: 4px 16px;
    padding: 0 16px;
    background: #fff;
    border-radius: 99px;
    height: 44px;
    line-height: 44px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: @fontMedium;
    color: @gray;
    img {
      width: 24px;
      height: 24px;
    }
  }
  .column-box {
    display: flex;
    align-items: center;
    margin: 0 0 8px;
    padding-top: 24px;
    background: linear-gradient(180deg, transparent 0%, #fff 30%);
    .column {
      display: flex;
      flex-direction: column;
      align-items: center;
      flex: 1;
      margin-bottom: 8px;
      img {
        width: 52px;
        height: 52px;
        margin-bottom: 12px;
      }
    }
  }
}
</style>
